import { render, staticRenderFns } from "./IconRentalObject.vue?vue&type=template&id=12a67ead&"
import script from "./IconRentalObject.vue?vue&type=script&lang=ts&"
export * from "./IconRentalObject.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports